import type { ReactNode } from "react"

import { THEME } from "@/3514/theme"
import { ESessionInvitationStatus } from "@/3514/types"

import { ESpecialChar, SpecialChars } from "../typography/special-char"

const symbolsMap: { [A in ESessionInvitationStatus]: ReactNode } = {
    [ESessionInvitationStatus.Present]: (
        <svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M0.65625 3.09306L2.70082 5.3235L7.34755 0.676758"
                stroke={THEME.COLORS.black}
                strokeWidth="0.9"
                strokeLinecap="square"
            />
        </svg>
    ),
    [ESessionInvitationStatus.Accepted]: (
        <svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M0.65625 3.09306L2.70082 5.3235L7.34755 0.676758"
                stroke="#6F6F6F"
                strokeWidth="0.9"
                strokeLinecap="square"
            />
        </svg>
    ),
    [ESessionInvitationStatus.Pending]: SpecialChars[ESpecialChar.QuestionMark],
    [ESessionInvitationStatus.Tentative]: SpecialChars[ESpecialChar.QuestionMark],
    [ESessionInvitationStatus.NotPresent]: SpecialChars[ESpecialChar.Cross],
    [ESessionInvitationStatus.Declined]: SpecialChars[ESpecialChar.Cross]
}

const config = { symbolsMap }

export { config as rsvpMarkConfig }
